import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  deleteAppear,
  deleteAppearDone,
  deleteAppearFail,
  deleteMedicalResult,
  deleteMedicalResultDone,
  deleteMedicalResultFail,
  deletePrintRemark,
  deletePrintRemarkDone,
  deletePrintRemarkFail,
  editPrintRemark,
  editPrintRemarkDone,
  editPrintRemarkFail, editPrintStudy, editPrintStudyDone, editPrintStudyFail,
  getAppearByID,
  getAppearByIDDone,
  getAppearByIDFail,
  getDisciplinesPrintTotalUvr, getDisciplinesPrintTotalUvrDone,
  getDisciplinesPrintTotalUvrFail, getFilteredAppear, getFilteredAppearDone, getFilteredAppearFail, getFilteredGroups, getFilteredGroupsDone, getFilteredGroupsFail,
  getPrintMedical,
  getPrintMedicalDone,
  getPrintMedicalFail,
  getPrintMedicalGroup,
  getPrintMedicalGroupDone,
  getPrintMedicalGroupFail,
  getPrintModule,
  getPrintModuleDone,
  getPrintModuleFail,
  getPrintRemark,
  getPrintRemarkDone,
  getPrintRemarkFail,
  getPrintStudy,
  getPrintStudyDone,
  getPrintStudyFail,
  getPrintTotalUvr,
  getPrintTotalUvrDone,
  getPrintTotalUvrFail,
  getStudentByGroupID,
  getStudentByGroupIDDone,
  getStudentByGroupIDFail,
  getTeachersList,
  getTeachersListDone,
  getTeachersListFail,
  postAppear,
  postAppearDone,
  postAppearFail,
  printJournal, printJournalDone, printJournalFail, printJournalParams, printJournalParamsDone,
  printJournalParamsFail, printJournalSubjectList, printJournalSubjectListDone, printJournalSubjectListFail,
  printMedicalEdit,
  printMedicalEditDone,
  printMedicalEditFail,
  printModuleEdit,
  printModuleEditDone,
  printModuleEditFail,
  putAppear,
  putAppearDone,
  putAppearFail,
  setPrintRemark,
  setPrintRemarkDone,
  setPrintRemarkFail,
} from "./actions";
import {
  apiAppear,
  apiDeleteRemark, apiDisciplinesTotalUvr,
  apiEditRemark,
  apiMedical,
  apiMedicalEdit,
  apiMedicalGroup,
  apiModuleEdit,
  apiModules, apiPrintJournal, apiPrintJournalParams, apiPrintJournalSubjectList,
  apiRemark,
  apiSetRemark,
  apiStudy, apiStudyEdit, apiTotalUvr, getGroupsApi,
  apiStudentsByGroup,
  apiAppealEditOrPost,
  apiAppealDelete,
  apiAppealByID,
  apiDeleteMedical,
  apiGetPrintTeachers
} from "./api";

import { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../index";
import { selectStore } from "../../selector";

function* getPrintModuleFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiModules, payload)
    if (data) {
      yield put(getPrintModuleDone(data.data))
    }
  } catch (e) {
    yield put(getPrintModuleFail())
  }
}

function* editPrintModuleFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiModuleEdit, payload)
    if (data.status === 200) {
      yield put(printModuleEditDone(payload))
    }
  } catch (e) {
    yield put(printModuleEditFail())
  }
}

function* getPrintStudyFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiStudy, payload)
    if (data) {
      yield put(getPrintStudyDone(data.data))
    }
  } catch (e) {
    yield put(getPrintStudyFail())
  }
}

function* editPrintStudyFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiStudyEdit, payload)
    if (data) {
      yield put(editPrintStudyDone(data.data))
    }
  } catch (e) {
    yield put(editPrintStudyFail())
  }
}

function* getPrintMedicalFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiMedical, payload)
    if (data) {
      yield put(getPrintMedicalDone(data.data))
    }
  } catch (e) {
    yield put(getPrintMedicalFail())
  }
}

function* getPrintMedicalGroupsFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiMedicalGroup, payload)
    if (data) {
      yield put(getPrintMedicalGroupDone(data.data))
    }
  } catch (e) {
    yield put(getPrintMedicalGroupFail())
  }
}

function* editPrintMedicalFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiMedicalEdit, payload)

    if (data.status === 200) {
      yield put(printMedicalEditDone(data.data))
    }
  } catch (e) {
    yield put(printMedicalEditFail())
  }
}

function* getPrintRemarkFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiRemark, payload)

    if (data.data) {
      yield put(getPrintRemarkDone(data.data))
    }
  } catch (e) {
    yield put(getPrintRemarkFail())
  }
}

function* setPrintRemarkFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiSetRemark, payload)

    if (data.data) {
      yield put(setPrintRemarkDone(data.data))


      // @ts-ignore
      yield call(getPrintRemarkFlow, { payload: payload })
    }
  } catch (e) {
    yield put(setPrintRemarkFail())
  }
}

function* editPrintRemarkFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiEditRemark, payload)

    if (data.data) {
      yield put(editPrintRemarkDone(data.data))
    }
  } catch (e) {
    yield put(editPrintRemarkFail())
  }
}

function* deletePrintRemarkFlow({ payload }: PayloadAction<any>): any {
  console.log('payload', payload)
  try {
    const data = yield call(apiDeleteRemark, payload)

    if (data.data) {
      yield put(deletePrintRemarkDone(data.data))
    }
  } catch (e) {
    yield put(deletePrintRemarkFail())
  }
}

function* getPrintTotalUvrFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiTotalUvr, payload)

    if (data.data) {
      yield put(getPrintTotalUvrDone(data.data))
    }
  } catch (e) {
    yield put(getPrintTotalUvrFail());
  }
}

function* getDisciplinesPrintTotalUvrFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiDisciplinesTotalUvr, payload)

    if (data.data) {
      yield put(getDisciplinesPrintTotalUvrDone(data.data))
    }
  } catch (e) {
    yield put(getDisciplinesPrintTotalUvrFail())
  }
}


function* printJournalFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiPrintJournal, payload)

    if (data.data) {
      window.open(data?.data?.link, '_blank')
      yield put(printJournalDone(data.data))
    }
  } catch (e) {
    yield put(printJournalFail())
  }
}

function* printJournalParamsFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiPrintJournalParams, payload)

    if (data.data) {
      yield put(printJournalParamsDone(data.data))
    }
  } catch (e) {
    yield put(printJournalParamsFail())
  }
}

function* printJournalSubjectListFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiPrintJournalSubjectList, payload)

    if (data.data) {
      yield put(printJournalSubjectListDone(data.data))
    }
  } catch (e) {
    yield put(printJournalSubjectListFail())
  }
}


function* getFilteredGroupsFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(getGroupsApi, payload)

    if (data?.data?.data?.groupsWithStudentsByCourse) {
      yield put(getFilteredGroupsDone(data?.data?.data?.groupsWithStudentsByCourse))
    }
  } catch (e) {
    yield put(getFilteredGroupsFail())
  }
}

function* getStudentsByGroupFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiStudentsByGroup, payload)

    if (data?.data) {
      yield put(getStudentByGroupIDDone(data?.data))
    }
  } catch (e) {
    yield put(getStudentByGroupIDFail())
  }
}


function* getFilteredAppearFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiAppear, payload)

    if (data?.data) {
      yield put(getFilteredAppearDone(data?.data))
    }
  } catch (e) {
    yield put(getFilteredAppearFail())
  }
}


function* postAppearFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiAppealEditOrPost, payload)

    if (data?.data) {
      yield put(postAppearDone(data?.data))
    }
  } catch (e) {
    yield put(postAppearFail())
  }
}

function* putAppearFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiAppealEditOrPost, payload)

    if (data?.data) {
      yield put(putAppearDone(data?.data))
    }
  } catch (e) {
    yield put(putAppearFail())
  }
}


function* deleteAppearFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiAppealDelete, payload)

    if (data?.data) {
      yield put(deleteAppearDone(data?.data))
    }
  } catch (e) {
    yield put(deleteAppearFail())
  }
}

function* getAppearByIdFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiAppealByID, payload)

    if (data?.data) {
      yield put(getAppearByIDDone(data?.data))
    }
  } catch (e) {
    yield put(getAppearByIDFail())
  }
}

function* deleteMedicalResultFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiDeleteMedical, payload)

    if (data?.data) {
      yield put(deleteMedicalResultDone(data?.data))
    }
  } catch (e) {
    yield put(deleteMedicalResultFail())
  }
}

function* teachersListFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetPrintTeachers, payload)

    if (data?.data) {
      const result = Object.keys(data?.data).map((item) => {
        return {
          value: Number(item),
          label: data?.data[item]
        }
      })
      
      yield put(getTeachersListDone(result))
    }
  } catch (e) {
    yield put(getTeachersListFail())
  }
}



export default function* profileSaga() {
  yield takeLatest(getTeachersList, teachersListFlow);
  yield takeLatest(getAppearByID, getAppearByIdFlow);
  yield takeLatest(deleteAppear, deleteAppearFlow);
  yield takeLatest(postAppear, postAppearFlow);
  yield takeLatest(putAppear, putAppearFlow);
  yield takeLatest(getStudentByGroupID, getStudentsByGroupFlow);
  yield takeLatest(getFilteredAppear, getFilteredAppearFlow);
  yield takeLatest(getPrintModule, getPrintModuleFlow);
  yield takeLatest(printModuleEdit, editPrintModuleFlow);
  yield takeLatest(getPrintStudy, getPrintStudyFlow);
  yield takeLatest(editPrintStudy, editPrintStudyFlow);
  yield takeLatest(getPrintMedical, getPrintMedicalFlow);
  yield takeLatest(getPrintMedicalGroup, getPrintMedicalGroupsFlow);
  yield takeLatest(printMedicalEdit, editPrintMedicalFlow);
  yield takeLatest(getPrintRemark, getPrintRemarkFlow);
  yield takeLatest(setPrintRemark, setPrintRemarkFlow);
  yield takeLatest(editPrintRemark, editPrintRemarkFlow);
  yield takeLatest(deletePrintRemark, deletePrintRemarkFlow);
  yield takeLatest(getPrintTotalUvr, getPrintTotalUvrFlow);
  yield takeLatest(getDisciplinesPrintTotalUvr, getDisciplinesPrintTotalUvrFlow);
  yield takeLatest(printJournal, printJournalFlow);
  yield takeLatest(printJournalParams, printJournalParamsFlow);
  yield takeLatest(printJournalSubjectList, printJournalSubjectListFlow);
  yield takeLatest(getFilteredGroups, getFilteredGroupsFlow);
  yield takeLatest(deleteMedicalResult, deleteMedicalResultFlow);

}
